module.exports = "https://web-assets.ifttt.com/packs/media/partners/trash-f65214fc.svg";